var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 375 374.999991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#54beff",
    d: "M 248.570312 85.617188 L 191.996094 122.824219 L 245.824219 151.699219 L 245.550781 151.855469 L 247.449219 212.535156 L 306.1875 177.011719 L 305.683594 117.402344 L 305.203125 117.679688 L 248.570312 85.617188"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTriangle);
export default __webpack_public_path__ + "static/media/BlueTriangle.8d1b9c62d6fcefc2c3b9ef4a1fb39281.svg";
export { ForwardRef as ReactComponent };